module.exports = __webpack_public_path__ + "img/Product management.26b18476.svg";